<template>
    <div class="card bossdb-citation-guidance">
        <div class="card-content">
            <div class="content">
                <h2 class="title is-4">Cite BossDB</h2>
                <p>
                    If BossDB supported the storage, access, or sharing of the
                    data associated with your publication, please cite the
                    BossDB paper. If it is useful for your manuscript, you can
                    also adapt the suggested acknowledgment below.
                </p>
                <p>Specific datasets can be cited using the citation tools on the project pages.</p>

                <h3 class="title is-6">Suggested Acknowledgment</h3>
                <blockquote class="suggested-ack">
                    The authors gratefully acknowledge BossDB.org for providing
                    data storage and access services that support the sharing of
                    the datasets associated with this publication (
                    <a href="https://reporter.nih.gov/project-details/10664562" target="_blank"
                        rel="noopener noreferrer">R24MH114785</a>, Hider et. al 2022 -
                    <a :href="bossdbPaperUrl" target="_blank" rel="noopener noreferrer">{{ bossdbPaperDoi }}</a>).
                </blockquote>

                <h3 class="title is-6">APA</h3>
                <pre class="citation-block">{{ bossdbPaperApa }}</pre>

                <h3 class="title is-6">BibTeX</h3>
                <pre class="citation-block">{{ bossdbPaperBibtex }}</pre>
            </div>
        </div>
    </div>
</template>

<script>
import {
    BOSSDB_PAPER_APA,
    BOSSDB_PAPER_BIBTEX,
    BOSSDB_PAPER_DOI,
    BOSSDB_PAPER_URL,
} from "@/bossdb_citation.js";

export default {
    name: "BossDBCitationGuidance",

    data() {
        return {
            bossdbPaperApa: BOSSDB_PAPER_APA,
            bossdbPaperBibtex: BOSSDB_PAPER_BIBTEX,
            bossdbPaperDoi: BOSSDB_PAPER_DOI,
            bossdbPaperUrl: BOSSDB_PAPER_URL,
        };
    },
};
</script>

<style scoped>
.citation-block {
    white-space: pre-wrap;
    word-break: break-word;
    background: #f7f7f7;
    border-radius: 0.75rem;
    padding: 1rem;
    font-size: 0.9rem;
}

.suggested-ack {
    background: #faf7ea;
    border-left: 4px solid #f2c037;
    padding: 1rem 1.25rem;
}
</style>
